import { logout } from '@services/auth.session';
import { isSafeRedirectUrl } from '@utils/urlValidation';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export const LogoutButton = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    logout();

    // Get redirect URL from query parameters and validate it
    const redirectUrl = searchParams.get('redirect');

    // Only include redirect parameter if the URL is actually safe and not just the root
    if (redirectUrl && isSafeRedirectUrl(redirectUrl) && redirectUrl !== '/') {
      // Navigate to login with validated redirect as query parameter
      // This ensures the redirect is handled safely after login
      navigate(`/login?redirect=${encodeURIComponent(redirectUrl)}`, { replace: true });
    } else {
      // Normal logout without redirect (for malicious URLs or root path)
      navigate('/login', { replace: true });
    }
  }, [navigate, searchParams]);

  return null;
};
